<template>
  <div class="apply-form__section apply-form__privacy-policy">
    <h2>{{ $t('privacyPolicy') }}</h2>

    <div v-if="shortPrivacyPolicy" v-html="localize(this.shortPrivacyPolicy)" />
    <div v-else v-html="$t('privacyPolicyText')" />

    <!-- <i18n path="privacyPolicyText">
      <a v-if="customDataPrivacyUrl" :href="customDataPrivacyUrl" target="_blank">
        {{ $t('here') }}
      </a>

      <router-link v-else :to="{ name: 'privacyPolicy' }">{{
        $t('here')
      }}</router-link>
      
    </i18n> -->

    <div>
      <ValidationProvider
        v-slot="{ errors }"
        name="privacyPolicyConfirmed"
        ref="privacyPolicyProvider"
        rules="isTrue"
        :custom-messages="{
          isTrue: $t('validation.privacyPolicyInvalid')
        }"
      >
        <v-checkbox
          v-model="policyAccepted"
          :label="$t('acceptPrivacyPolicy')"
          :error-messages="errors"
        ></v-checkbox>
      </ValidationProvider>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    shortPrivacyPolicy: {
      type: String,
      required: false,
      default: null
    }
  },

  computed: {
    ...mapState('companyModule', {
      customDataPrivacyUrl: 'customDataPrivacyUrl'
    }),

    policyAccepted: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  methods: {
    resetPolicyValidation() {
      this.$refs.privacyPolicyProvider?.reset();
    },

    async validatePolicy() {
      const provider = this.$refs.privacyPolicyProvider;
      if (!provider) {
        return true;
      }

      const result = await provider.validate();
      return result.valid;
    }
  }
};
</script>
